<template>
  <div class="fab-container">
    <div class="fab-parent fab-icon-holder">
      <i class="fa fa-chevron-up"></i>
    </div>
    <ul class="fab-options">
      <li>
        <span class="fab-label">
          <router-link :to="{ name: 'EmployeesFoldersMediaAdd' }">
            {{ $t("foldersMedias.add") }}
          </router-link>
        </span>
        <div class="fab-icon-holder">
          <router-link :to="{ name: 'EmployeesFoldersMediaAdd' }">
            <img src="@/assets/images/plus.svg" />
          </router-link>
        </div>
      </li>
      <li>
        <span class="fab-label" @click="open">
          {{ $t("filter") }}
        </span>
        <div class="fab-icon-holder" @click="open">
          <img src="@/assets/images/filter.svg" />
        </div>
      </li>
    </ul>

    <vue-bottom-sheet ref="CustomBottomSheet">
      <div class="row">
        <!-- <CustomSelectBox
          :className="'col-md-12'"
          :id="'employeeToken'"
          :value="filterData.employeeToken"
          :options="employeeTokenOptions"
          v-on:changeValue="changeEmployee($event)"
          :title="$t('selectEmployee')"
          :imgName="'man.svg'"
        /> -->
        <!-- <CustomSelectBox
          v-if="!isLoading"
          :className="'col-md-12'"
          :id="'employeeFolderToken'"
          :value="filterData.employeeFolderToken"
          :options="employeeFolderTokenOptions"
          v-on:changeValue="filterData.employeeFolderToken = $event"
          :title="$t('employeeFolders.select')"
          :imgName="'media.svg'"
        /> -->
        <CustomInput
          :className="'col-md-12'"
          :id="'textSearch'"
          :value="filterData.textSearch"
          :title="$t('search')"
          :imgName="'search.svg'"
          v-on:changeValue="filterData.textSearch = $event"
        />
      </div>

      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="search"
        >
          {{ $t("search") }}
        </button>
        <button class="btn btn-cancel" @click.prevent="close">
          {{ $t("cancel") }}
        </button>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import { STATUS } from "@/utils/constants";
// import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import EmployeeFolders from "@/models/employees/employeeFolders/EmployeeFolders";
import Employee from "@/models/employees/employees/Employee";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "FolderMediaFloatBtns",
  mixins: [createToastMixin],
  props: {
    theFilterData: {
      type: Object,
    },
  },
  data() {
    return {
      filterData: this.theFilterData,
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      employeeFolders: new EmployeeFolders(),
      employeeFolderTokenOptions: [],
      employeeData: new Employee(),
      employeeTokenOptions: [],
    };
  },
  components: {
    // CustomSelectBox,
    CustomInput,
  },
  methods: {
    open() {
      this.$refs.CustomBottomSheet.open();
    },
    close() {
      this.$refs.CustomBottomSheet.close();
    },
    search() {
      this.close();
      this.$emit("search", this.filterData);
    },
    async getDialogOfEmployeeFolders() {
      this.isLoading = true;
      // this.employeeFolders.filterData.employeeToken =
      //   this.filterData.employeeToken;
      this.employeeFolderTokenOptions = [];
      this.employeeFolderTokenOptions.push({
        value: "",
        text: this.$t("employeeFolders.select"),
      });
      try {
        let response =
          await this.employeeFolders.employeeFolder.getDialogOfEmployeeFolders(
            this.language,
            this.userAuthorizeToken,
            this.employeeFolders.filterData
          );
        const itemsData = response.data.itemsData;

        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeFolderTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    // changeEmployee(data) {
    //   this.filterData.employeeToken = data;
    //   this.filterData.employeeFolderToken = "";
    //   this.getDialogOfEmployeeFolders();
    // },
    async getDialogOfEmployees() {
      this.isLoading = true;
      this.employeeTokenOptions = [];
      this.employeeTokenOptions.push({
        value: "",
        text: this.$t("selectEmployee"),
      });
      try {
        let response = await this.employeeData.getDialogOfEmployees(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    // this.getDialogOfEmployeeFolders();
    // this.getDialogOfEmployees();
  },
};
</script>
